import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  FormGroup,
  Row,
  FormControl,
  Col,
  Button,
  ButtonToolbar,
  ControlLabel,
} from 'react-bootstrap';
import { Field, reduxForm, formPropTypes, SubmissionError } from 'redux-form';

import ClickableList from '../../../../components/ClickableList/index';
import { createRenderer } from '../../../reduxForm/utils';
import { typeAheadListFiltering } from '../../../../utils/typeAheadListFiltering';

export const FORM_NAME = 'wellForm';
const INPUT_LENGTH_BEFORE_FILTERING = 1;

const propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  dispatchUpdateWell: PropTypes.func.isRequired,

  joinType: PropTypes.string.isRequired,
  lookupStatus: PropTypes.string,
  leaseId: PropTypes.number,

  /* eslint-disable react/forbid-prop-types */
  initialValues: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */

  ...formPropTypes,
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Required';
  }
  return errors;
};

const RenderInput = createRenderer((input, label) => {
  return (
    <FormControl {...input} />
  );
});

class WellEditModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filteredWells: [],
    };

    this.handleUpdateWell = this.handleUpdateWell.bind(this);
    this.selectWell = this.selectWell.bind(this);
    this.resetAndClose = this.resetAndClose.bind(this);
    this.onChangeFiltering = this.onChangeFiltering.bind(this);
  }

  onChangeFiltering(e, newValue) {
    const { wellList } = this.props;
    const filteredWells = typeAheadListFiltering(newValue, INPUT_LENGTH_BEFORE_FILTERING, wellList);

    this.setState({ filteredWells });
  }

  selectWell(selectedWell) {
    const { change } = this.props;
    change('name', selectedWell.name);
  }

  resetAndClose() {
    const { reset, onHide } = this.props;
    reset();
    onHide();
  }

  async handleUpdateWell(values) {
    const { dispatchUpdateWell } = this.props;
    try {
      await dispatchUpdateWell(values);
    } catch (e) {
      const message = e.graphQLErrors.reduce((errorMessage, gqlError) => {
        return errorMessage + gqlError.details;
      }, '');
      throw new SubmissionError({ _error: message });
    }
  }


  render() {
    const { show, onHide, handleSubmit, invalid, error, submitting, pristine } = this.props;

    const { filteredWells } = this.state;

    return (
      <Modal
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>Well</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(this.handleUpdateWell)}>
            <FormGroup>
              <Row>
                <Col xs={6}>
                  <FormGroup>
                    <Field
                      name="name"
                      type="text"
                      label="Well"
                      component={RenderInput}
                      onChange={(e, newValue) => { return this.onChangeFiltering(e, newValue); }}
                    />
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <ControlLabel>Suggested Well Name </ControlLabel>
                  <ClickableList
                    list={filteredWells}
                    onSelect={this.selectWell}
                  />
                </Col>
              </Row>
            </FormGroup>
            <Row>
              <Col md={12}>
                <ButtonToolbar className="pull-right">
                  <Button
                    bsStyle="warning"
                    onClick={onHide}
                  >
                    Cancel
                  </Button>
                  <Button
                    bsStyle="primary"
                    type="submit"
                    disabled={submitting || pristine || invalid}
                  >
                    Update
                  </Button>
                </ButtonToolbar>
              </Col>
            </Row>
          </form>
          <label>{error && <strong>{error}</strong>}</label>
        </Modal.Body>
      </Modal>
    );
  }
}

WellEditModal.propTypes = propTypes;

WellEditModal.defaultProps = {
  initialValues: {},
  lookupStatus: null,
  leaseId: null,
};

export default reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
})(WellEditModal);
